import { useEffect, useState } from "react";

import { MenuChatDto, MenuSettingsDto } from "services/menu/restModels";

export const useChatsState = (settings: MenuSettingsDto | null) => {
    const [chats, setChats] = useState<MenuChatDto[]>([]);

    useEffect(() => {
        if (!settings) return;

        setChats(settings.chats);
    }, [settings]);

    const addChat = (chat: MenuChatDto) => setChats((prev) => [...prev, chat]);

    const updateChat = (index: number, chat: MenuChatDto) =>
        setChats((prev) => prev.map((item, i) => (i === index ? chat : item)));

    const removeChat = (index: number) =>
        setChats((prev) => prev.filter((_item, i) => i !== index));

    /*
    * Пара «мессенджер + chatId» должна быть уникальной: два одинаковых получателя
    * означали бы дубли уведомлений о каждом заказе.
    * */
    const isChatDuplicate = (chat: MenuChatDto, editIndex?: number) =>
        chats.some(
            (item, index) =>
                index !== editIndex &&
                item.messenger === chat.messenger &&
                item.chatId === chat.chatId &&
                item.botId === chat.botId
        );

    return { chats, addChat, updateChat, removeChat, isChatDuplicate };
};

export type ChatsState = ReturnType<typeof useChatsState>;
